export default class WorkPlanAssignmentOfEvaluatorsCtrl {

  constructor ($scope, WorkPlanParametrizationSrv, $stateParams, $mdDialog, $interval, $uiGridConstants, i18nService, $state, GlobalConfig, $cookies, Validations) {
    this.WorkPlanParametrizationSrv = WorkPlanParametrizationSrv
    this.Validations = Validations
    this.$scope = $scope
    this.$mdDialog = $mdDialog
    this.GlobalConfig = GlobalConfig
    this.$interval = $interval
    this.gridApi = {}
    this.listTeacher = {}
    this.listRoles = []
    this.listSubModules = []
    this.listEvaluators = []
    this.isVisible = false
    this.workPlanAssignmentOfEvaluatorFilter = ''
    i18nService.setCurrentLang('es')

    this.user = JSON.parse($cookies.get('currentUser'))
    this.currentRoleId = JSON.parse($cookies.get('hasRoleId'))

    const singleFilter = (renderableRows) => {
      var matcher = new RegExp(this.workPlanAssignmentOfEvaluatorFilter,'i')
      renderableRows.forEach((row) => {
        var match = false;
        [ 'teacher_name', 'academic_unit_name', 'id_identification', 'teacher_type' ].forEach((field) => {
          if (row  && row.entity[field] && row.entity[field].match(matcher)) {
            match = true
          }
        })
        if (!match) {
          row.visible = false
        }
      })
      return renderableRows
    }

    this.$scope.gridAssignmentOfEvaluators = {
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      noUnselect: true,
      enableFiltering: true,
      columnDefs: [
        {
          name: 'Nombre de profesor',
          displayName: 'Nombre de profesor',
          field: 'teacher_name',
          width: '25%',
          headerCellClass: this.highlightFilteredHeader,
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        }, {
          name: 'Unidad académica',
          displayName: 'Unidad académica',
          field: 'academic_unit_name',
          width: '22%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        }, {
          name: 'Cédula',
          displayName: 'Cédula',
          field: 'id_identification',
          width: '15%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        }, {
          name: 'Tipo profesor',
          displayName: 'Tipo profesor',
          field: 'teacher_type',
          width: '25%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'text-xs',
          headerCellClass: 'font-normal text-xs'
        }, {
          name: 'Acciones',
          displayName: 'Acciones',
          field: 'evaluator',
          width: '15%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          cellClass: 'column-center text-xs text-azul',
          headerCellClass: 'column-center font-normal text-xs',
          cellTemplate: require('./cellAcctionAssignmentOfEvaluators.html')
        }
      ],
      onRegisterApi:(gridApi) => {
        this.gridApi = gridApi
        this.gridApi.grid.registerRowsProcessor(singleFilter, 200)        
        $interval(() => {
          this.gridApi.core.handleWindowResize()
        }, 500, 10)
      }
    }

    // INITIALIZATION
    this.activate()
  } //***************************Fin del construcctor***************************

activate () {
  this.getAssignmentOfEvaluator()
  this.getUsers()
}

getAssignmentOfEvaluator () {

  if (this.Validations.isAdminUnit(this.currentRoleId) || this.Validations.isGerencialConsultant(this.currentRoleId)){
    let header = { 
      userId : this.user.id,
      rolId  : this.currentRoleId
    }
    
  } 
  return this.WorkPlanParametrizationSrv.getAssignmentOfEvaluator.get(header).$promise.then((dataReturn) => {
    if (dataReturn.status) {
      this.$scope.gridAssignmentOfEvaluators.data = dataReturn.data
      return this.getTeacherSubmodules().then(this.getRoles())
    }
  })
}

getUsers () {
  this.editEvaluator = true
  this.WorkPlanParametrizationSrv.getUsers.get().$promise.then((dataReturn) => {
    if (dataReturn.status) {
      this.listEvaluators = dataReturn.data
      this.editEvaluator = false

      
    }
  })
}

checked(entity) {
  for( let idx in this.listTeacher ){
    if (this.listTeacher[idx] == entity)
      return true
  }
  return false
}

getTeacherSubmodules () {
  return this.WorkPlanParametrizationSrv.getTeacherSubmodules.get().$promise.then((dataReturn) => {
    if (dataReturn.status) {
      this.listSubModules = dataReturn.data
    }
  })
}

getRoles () {
  return this.WorkPlanParametrizationSrv.getRoles.get().$promise.then((dataReturn) => {
    if (dataReturn.status) {
      this.listRoles = dataReturn.data
    }
  })
}

// METHOD DEFINITIONS
highlightFilteredHeader (row, rowRenderIndex, col, colRenderIndex) {
  if (col.filters[0].term) {
    return 'header-filtered'
  } else {
    return ''
  }
}

filter () {
  this.gridApi.grid.refresh()
}

returnBack () {
  window.history.back()
}

catchRow (teacher) {
  if (this.listTeacher[teacher.teacher_code]) {
    delete this.listTeacher[teacher.teacher_code]
  } else {
    this.listTeacher[teacher.teacher_code] = teacher
  }
  if (this.isVisible === false && !angular.equals(this.listTeacher, {})) {
    this.isVisible = true
  } else if (this.isVisible === true && angular.equals(this.listTeacher, {})) {
    this.isVisible = false
  }
}

showModalAssignmentOfEvaluators (teacher) {
      let listTeacher = {}
      if (teacher) {
        listTeacher[teacher.teacher_code] = teacher
      } else {
        listTeacher = this.listTeacher
      }
      var listEvaluators = this.listEvaluators
      var listSubModules = this.listSubModules
      var listRoles = this.listRoles
      var WorkPlanParametrizationSrv = this.WorkPlanParametrizationSrv
      var $interval = this.$interval
      var GlobalConfig = this.GlobalConfig
      var editEvaluator = this.editEvaluator
      this.$mdDialog.show({
        controller: ['$scope', '$mdDialog', '$state', function modalAssignmentOfEvaluators ($scope, $mdDialog, $state){
          $scope.saveButtonDisabled = true
          $scope.row = null
          $scope.listRoles = listRoles
          $scope.listEvaluatorsModal = []
          $scope.listEvaluators = []
          $scope.listEvaluatorsDelete=[]
          $scope.listTeacherSelected = listTeacher
          $scope.rolSelected = {}
          $scope.subModule = {}
          $scope.listSubModules = listSubModules
          $scope.WorkPlanParametrizationSrv = WorkPlanParametrizationSrv
          $scope.$interval = $interval
          $scope.GlobalConfig = GlobalConfig
          $scope.editEvaluator = editEvaluator

          if (teacher) {
                    // List evaluators
            $scope.WorkPlanParametrizationSrv.getTeacherEvaluator.get({idTeacher: teacher.teacher_code}).$promise.then((dataReturn) => {
              if (dataReturn.status) {
                $scope.listEvaluatorsModal = dataReturn.data
                for (var evaluator in $scope.listEvaluatorsModal) {
                  var idEvaluator = $scope.listEvaluatorsModal[evaluator].id_evaluator
                  var arrayIdSubModules = $scope.listEvaluatorsModal[evaluator].id_submodule.split(',')
                  var arrayNameSubModules = $scope.listEvaluatorsModal[evaluator].submodule.split(',')
                  var submodules = []
                  for (var count in arrayIdSubModules) {
                    var objectSubmodules = {
                      id_submodule: arrayIdSubModules[count],
                      submodule: arrayNameSubModules[count]
                    }
                    submodules.push(objectSubmodules)
                  }
                  var evaluators = [
                    {
                      id_evaluator: idEvaluator,
                      submodules: submodules
                    }
                  ]
                  $scope.listEvaluatorsModal[evaluator].evaluators = evaluators
                  if ( $scope.listEvaluatorsModal[evaluator].id_role === $scope.GlobalConfig.userRolesIds.approver) {
                    let roleId = $scope.listRoles.findIndex( role => role.id_code === $scope.GlobalConfig.userRolesIds.approver)
                    $scope.listRoles[roleId].disable = true
                  }
                }
              } else {
                $scope.listEvaluatorsModal = {}
              }
            })
          }
          $scope.close = () => {
            $scope.listRoles = $scope.listRoles.map( (role) =>{
              role.disable = false
              return role
            })
            $mdDialog.hide()
          }

          $scope.gridModalEvaluators = {
            enableFiltering: false,
            enableRowSelection: true,
            enableRowHeaderSelection: false,
            multiSelect: false,
            modifierKeysToMultiSelect: false,
            noUnselect: true,
            columnDefs: [{
              name: 'Nombre',
              displayName: 'Nombre',
              field: 'ds_fullname',
              width: '60%',
              headerCellClass: $scope.highlightFilteredHeader,
              enableGridMenu: false,
              enableHiding: false,
              enablePinning: false,
              enableColumnMenu: false,
              enableSorting: false,
              cellClass: 'column-left',
              headerCellClass: 'column-left font-normal exo' // DUPLICATE KEY
            }, {
              name: 'Cédula',
              displayName: 'Cédula',
              field: 'ds_identification',
              width: '40%',
              enableGridMenu: false,
              enableHiding: false,
              enablePinning: false,
              enableColumnMenu: false,
              enableSorting: false,
              cellClass: 'column-center',
              headerCellClass: 'column-center font-normal exo'
            }],
            onRegisterApi: (gridApi) => {
              $scope.gridApi = gridApi
              $scope.gridApi.grid.registerRowsProcessor($scope.modalSingleFilter, 200)
              $interval(() => {
                $scope.gridApi.core.handleWindowResize()
              }, 500, 10)
              gridApi.selection.on.rowSelectionChanged($scope,(row) => {
                $scope.row = row.entity// User Selected
              })

              // gridApi.core.on.filterChanged( this.$scope, () => {
              //   var grid = gridApi.grid.renderContainers.body.grid;
              //   var filters={}

              //   for(let i in grid.columns){
              //     if ((grid.columns[i].filters[0].term!='')&&(grid.columns[i].filters[0].term!=undefined)){
              //       filters[grid.columns[i].field]=grid.columns[i].filters[0].term;
              //     }
              //   }

              //   this.gridOptions.paginationNumber=1;
              //   this.filtered = {
              //     ID_SIMULACION: this.simulation.id, 
              //     newPage: 1,
              //     pageSize: this.gridOptions.paginationPageSize,
              //     filters: filters
              //   }
              //   console.log('-------------------------------------------------------------');
              //   console.log('this.inExecution->', this.inExecution);
              //   if (!this.inExecution) {
              //     console.log('entro');
              //     this.inExecution = true
              //     this.$timeout(() => {
              //       console.log('estoy en el timeout');
              //       console.log('this.filtered->', this.filtered); 
              //       this.services.getDataReport(this.filtered).$promise.then((response) => {
              //         console.log('se ejecuto');
              //         this.inExecution = false
              //         this.agregaPadre(response);
              //         this.gridOptions.data = response.data;
              //       }, (err) => {
              //         this.inExecution = false
              //       });

              //     }, 600);
              //   }
              //   console.log('-------------------------------------------------------------');   
              // });

              gridApi.pagination.on.paginationChanged(this.$scope, (newPage, pageSize) => {
                console.log('-------------------------------------------------------------')
                console.log('newPage ->', newPage )
                console.log('pageSize ->', pageSize )
                console.log('-------------------------------------------------------------')
                // var grid = gridApi.grid.renderContainers.body.grid;
                // var filters={}
                // for(let i in grid.columns){
                //   if ((grid.columns[i].filters[0].term!='')&&(grid.columns[i].filters[0].term!=undefined)){
                //     filters[grid.columns[i].field]=grid.columns[i].filters[0].term;
                //   }
                // }

                // let params = {
                //   ID_SIMULACION: this.simulation.id, 
                //   newPage:newPage,
                //   pageSize:pageSize,
                //   filters:filters
                // }

                // this.services.getDataReport(params).$promise.then((response) => {
                //   this.agregaPadre(response);
                // });
              });
            }
          }

          $scope.gridModalEvaluators.data = listEvaluators

          $scope.onRoleSelected = function(rolSelected) {
            clearSelectedActivities()
            if (rolSelected && rolSelected.id_code === $scope.GlobalConfig.userRolesIds.approver) {
              selectAllActivities()
            }
          }

          function selectAllActivities() {
            $scope.listSubModules.forEach( (listModules) =>{
              $scope.subModule[listModules.id_code] = true
            })
          }

          function clearSelectedActivities() {
            $scope.listSubModules.forEach( (listModules) =>{
              $scope.subModule[listModules.id_code] = false
            })
          }

          $scope.isSubModuleDisabled = function(listModules) {
            if ($scope.rolSelected) {
              if (!$scope.rolSelected.id_code || $scope.rolSelected.id_code === $scope.GlobalConfig.userRolesIds.approver) {
                return true
              }else{
                if($scope.rolSelected.id_code === $scope.GlobalConfig.userRolesIds.reviewer) {
                  return activityExist(listModules.id_code)
                }
              }
            }else{
              return true
            }
            return false
          }

          function activityExist(activityId) {
            if ( $scope.listEvaluatorsModal ) {
              let found = $scope.listEvaluatorsModal.find( evaluator => {
                if (evaluator.is_active ===1 && evaluator.id_role === $scope.GlobalConfig.userRolesIds.reviewer) {
                  return evaluator.evaluators.find( object =>{
                    let a = object.submodules.find( submodule => submodule.id_submodule == activityId)
                    if (a)
                      return a
                  })
                }
              })
              if( found ) {
                return true
              }else{
                return false
              }
            }
            return false
          }

          $scope.subModuleEmpty = function() {
            for (let id in $scope.subModule) {
              if ($scope.subModule[id])
                return false
            }
            return true
          }
          
          // Function Add Evaluators
          $scope.addEvaluators = () => {
            $scope.saveButtonDisabled = false
            if (!$scope.row ||  !$scope.rolSelected.id_code || $scope.subModuleEmpty() )
              return
            // disable specific role
            if ($scope.rolSelected.id_code === $scope.GlobalConfig.userRolesIds.approver) {
              let roleId = $scope.listRoles.findIndex( role => role.id_code === $scope.GlobalConfig.userRolesIds.approver)
              $scope.listRoles[roleId].disable = true
            }
            var userTemp=[];
            var userRoleTemp=[];

            for (var idTeacher in $scope.listTeacherSelected) {
              var assignment = {
                evaluator_name: $scope.row.ds_fullname,
                id_teacher: $scope.listTeacherSelected[idTeacher].teacher_code,
                is_active: $scope.row.is_active,
                role_name: $scope.rolSelected.ds_name,
                id_role: $scope.rolSelected.id_code,
                id_identification:$scope.listTeacherSelected[idTeacher].id_identification
              }
             
              var array = []
              var submoduleNames = ''
              var idSubModules = ''
          
                    for (let id in $scope.subModule) {
                      if( $scope.subModule[id] ) {

                        let object = $scope.listSubModules.find(element => element.id_code == id)

                        array.push({
                          id_submodule: object.id_code,
                          submodule: object.ds_name
                        })

                        if (submoduleNames === '' && idSubModules === '') {
                          idSubModules = object.id_code
                          submoduleNames = object.ds_name
                        } else {
                          idSubModules = idSubModules + ', ' + object.id_code
                          submoduleNames = submoduleNames + ', ' + object.ds_name
                        }
                      }
                    }
                    let evaluator = [
                      {id_evaluator: $scope.row.id_code,
                        submodules: array}
                    ]
                    assignment.evaluators = evaluator
                    assignment.submodule = submoduleNames
                   
                    $scope.listEvaluators.push(assignment)

                   
              if($.inArray($scope.listTeacherSelected[idTeacher].id_identification,userTemp) == -1 && $.inArray($scope.rolSelected.id_code,userRoleTemp) == -1 ) {  
                 $scope.listEvaluatorsModal.push(assignment)
               }

                 userTemp.push($scope.listTeacherSelected[idTeacher].id_identification);
                 userRoleTemp.push($scope.rolSelected.id_code);
            }


            $scope.row = null
            $scope.subModule = {}
            $scope.gridApi.selection.clearSelectedRows()
          }

          $scope.listEvaluatorsModalEmpty = function() {
            if($scope.listEvaluatorsModal.length === 0){
              return true
            }else{
              return !$scope.listEvaluatorsModal.find( (evaluator) =>{
                if(evaluator.is_active === 1)
                  return true
              })
            }
            return true
          }

          $scope.filter = () => {            
            $scope.gridApi.grid.refresh()
          }

          $scope.modalSingleFilter = (renderableRows) => {
            var matcher = new RegExp($scope.gridModalAssignmentOfEvaluators,'i')
            renderableRows.forEach((row) => {
              var match = false;
              [ 'ds_fullname', 'ds_name', 'ds_identification' ].forEach((field) => {
                if (row.entity[field] && row.entity[field].match(matcher)) {
                  match = true
                }
              })
              if (!match) {
                row.visible = false
              }
            })
            return renderableRows
          }

          function showModalSucess () {      
            $mdDialog.show({
              controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
                let ctrlModal = this          
      
                $scope.close = function (){            
                  $mdDialog.hide();
                }          
      
              }],
              controllerAs: 'ctrlModal',
              template: require('./modalSuccesReviewer.html'),
              clickOutsideToClose: false
            })
          }

          $scope.saveAssignment = () => {
            $scope.saveButtonDisabled = true
            let header = {
              values: $scope.listEvaluators,
              listDisableEvaluators: $scope.listEvaluatorsDelete 
            }
            $scope.WorkPlanParametrizationSrv.addTeacherEvaluator.add(header).$promise.then((dataReturn) => {
              if (dataReturn.status) {
                $state.reload()
                $mdDialog.hide()
                showModalSucess()
              }else{
                $scope.saveButtonDisabled = false
              }
            })
          }

          $scope.deleteAssociation = (evaluator) => {
            if( evaluator.id_role === $scope.GlobalConfig.userRolesIds.approver) {
              let roleId = $scope.listRoles.findIndex( role => role.id_code === $scope.GlobalConfig.userRolesIds.approver)
              $scope.listRoles[roleId].disable = false
            }
            evaluator.is_active = 0
            $scope.listEvaluatorsDelete.push(evaluator)
            $scope.saveButtonDisabled = false
          }
        }],
        template: require('./modalAssignmentOfEvaluators.html'),
        clickOutsideToClose: false
      })
    }
}
WorkPlanAssignmentOfEvaluatorsCtrl.$inject = ['$scope', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$state', 'GlobalConfig', '$cookies', 'Validations']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/reviewers/workPlanAssignmentOfEvaluatorsCtrl.js